import { render, staticRenderFns } from "./weekdays2.vue?vue&type=template&id=bb596b04&"
import script from "./weekdays2.vue?vue&type=script&lang=js&"
export * from "./weekdays2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports